import React, { Component } from 'react';
import { AuthorizationService } from "../service/AuthorizationService";
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import {Checkbox} from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import config from '../config';

import ADB2CLogin from './adb2c/ADB2CLogin';

export class ClientLogin extends Component {

    constructor() {
        super();
        this.state = {
            loading: true,
            username: '',
            password: '',
            isSignup: false,
            name: "",
            email: "",
            extraFields: {},
            termsOfUseAcceptedOn: '',
            showUseTerms: false
        };

        this.authorizationService = new AuthorizationService();
        this.callbackADB2C = this.callbackADB2C.bind(this);
    }

    async componentDidMount() {

        await this.setState({ loading: false, client: this.props.client, isSignup: window.location.pathname.endsWith('/signup') });
    }

    async login(){
        const { username, password, client } = this.state;
        try {
            if(username === "" || password === "")
            {
                throw new Error();
            }
            await this.setState({authenticating: true, authenticationFailed: false});
            const user = await this.authorizationService.login(username, password, client.id);
            user.client = client;
            await this.props.onAuthenticated(user)
        } catch (error) {
            console.log(error);
            await this.setState({authenticating: false, authenticationFailed: true});
        }
    }

    async signup(){
        const { name, email, client, extraFields, termsOfUseAcceptedOn } = this.state;
        try {
            if(name === "" || email === "")
            {
                throw new Error();
            }
            await this.setState({creating: true, creationFailed: false, creationSucceeded: false, creationFailedReason: ''});
            await this.authorizationService.signup(name, email, extraFields, termsOfUseAcceptedOn, client.id);

            if((client.config.authenticationType || "local") === "ADB2C"){
                await this.setState({creating: false, creationFailed: false, creationSucceeded: false, isSignup: false});
            }
            else
            {
                await this.setState({creating: false, creationFailed: false, creationSucceeded: true});
            }
        } catch (error) {
            console.log(error);
            await this.setState({creating: false, creationFailed: true, creationSucceeded: false, creationFailedReason: error});
        }
    }

    isSignupValid(){
        const { name, email, extraFields, client, termsOfUseAcceptedOn } = this.state;
        if(name === "") return false;
        if(email === "") return false;
        for(let i = 0; i < (client.signup_config.extraFields || []).length; i++)
        {
            const extraField = client.signup_config.extraFields[i];
            if((extraFields[extraField.id] || "") === "") return false;
        };

        if(client.signup_config.acceptTermsEnabled && termsOfUseAcceptedOn === '') return false;

        return true;
    }

    async updateExtraFields(fieldId, value){
        const { extraFields } = this.state;
        extraFields[fieldId] = value;
        this.setState({extraFields});
    }

    async requestPasswordReset(){
        const { username, client } = this.state;
        try {
            if((username || "") === ""){
                await this.setState({authenticating: false, requestPasswordResetOk: false, requestPasswordResetFailed: true, requestPasswordResetFailReason: "Informe seu e-mail"});
            }
            else{
                await this.setState({authenticating: true, requestPasswordResetOk: false, requestPasswordResetFailed: false, requestPasswordResetFailReason: ''});
                const user = await this.authorizationService.requestPasswordReset(username, client.id);
                user.client = client;
                await this.setState({authenticating: false, requestPasswordResetOk: true, requestPasswordResetFailed: false, requestPasswordResetFailReason: ''});
            }
        } catch (error) {
            console.log(error);
            await this.setState({authenticating: false, requestPasswordResetOk: false, requestPasswordResetFailed: true, requestPasswordResetFailReason: error.toString()});
        }
    }

    async callbackADB2C({ status, accountId, token, name })
    {
        console.log({ status, accountId, token });
        const { client } = this.state;
        try {
            await this.setState({authenticating: true, authenticationFailed: false});
            const user = await this.authorizationService.loginWithADB2C(accountId, token, client.id);
            user.client = client;
            await this.props.onAuthenticated(user)
        } catch (error) {
            if(error === "Not signed up"){
                await this.setState({authenticating: false, authenticationFailed: false, isSignup: true, name, email: accountId })
            }
            else {
                console.log(error);
                await this.setState({authenticating: false, authenticationFailed: true});
            }
        }
    }

    render() {        
        const { 
            loading, 
            client, 
            authenticating,
            authenticationFailed,
            requestPasswordResetOk,
            requestPasswordResetFailed,
            requestPasswordResetFailReason,
            isSignup,
            creating,
            creationFailed,
            creationSucceeded,
            creationFailedReason,
            termsOfUseAcceptedOn,
            showUseTerms
         } = this.state;

        if(loading){
            return <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                <ProgressSpinner strokeWidth="5"/>
            </div>
        }

        document.title = client.name;
        document.getElementById("favicon").href = client.custom_layout.favicon || "";

        if(isSignup)
        {
            return (
                <>
            
            <div style={{width: '100%', height: '100%', margin: 'auto',display:'flex', alignItems:'center', justifyContent: 'center', backgroundColor: client.custom_layout.secondaryBackgroundColor || ''}}>
                <Panel style={{width: '400px', margin: 'auto', backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                    <div className="p-grid" style={{backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                            <div className="p-col-12" style={{textAlign: 'center', marginTop:'20px'}}><img alt="Logo" src={client.logo} style={{maxWidth: '300px'}} /></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>Nome</b></div>
                            <div className="p-col-12"><InputText disabled={authenticating} value={this.state.name || ""} onChange={(e) => this.setState({name: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>E-mail</b></div>
                            <div className="p-col-12"><InputText disabled={authenticating || (client.config.authenticationType || "local") === "ADB2C"} value={this.state.email || ""} onChange={(e) => this.setState({email: e.target.value})} style={{width: '100%'}}/></div>

                            { (client.signup_config.extraFields || []).map(field => <>
                                <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>{field.label}</b></div>
                                <div className="p-col-12"><InputText disabled={authenticating} value={this.state.extraFields[field.id] || ""} onChange={(e) => this.updateExtraFields(field.id, e.target.value)} style={{width: '100%'}}/></div>
                            </>)}

                            { client.signup_config.acceptTermsEnabled && <>
                                <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || '', fontSize: '14px'}}>
                                    <Checkbox onChange={e => this.setState({termsOfUseAcceptedOn: termsOfUseAcceptedOn === '' ? new Date() : ''})} checked={termsOfUseAcceptedOn !== ''}></Checkbox>
                                    &nbsp;&nbsp;<b>Termos de Uso:</b> ao marcar este checkbox confirmo que li e aceito os <Link onClick={() => this.setState({showUseTerms: true})}>Termos de Uso</Link>
                                </div>
                            </>}
                            

                            <div className="p-col-12" style={{textAlign: 'center'}}>
                                <Button 
                                    disabled={creating || !this.isSignupValid()} 
                                    label={"Cadastrar"}
                                    onClick={() => this.signup()}
                                    style={{backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                />
                                <Button 
                                    disabled={creating} 
                                    label={"Voltar"}
                                    onClick={() => window.location.href = `${client.use_custom_url ? `/` : `/${client.shortcode}`}`}
                                    style={{marginLeft: '10px', backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                />
                                { creating && <div style={{marginTop: '10px'}}><ProgressBar mode="indeterminate"/></div> }
                                { creationFailed && <>
                                    <br/>
                                    <Message severity="error" text={creationFailedReason === "Already_Exists" ? "Já cadastrado" : "Dados invalidos"} closable={false} style={{marginTop: '10px'}}/>
                                </>}
                                { creationSucceeded && <>
                                    <br/>
                                    <Message severity="success" text={"Verifique sua caixa de e-mail. Foram enviadas instruções para criação de sua senha de acesso"} closable={false} style={{marginTop: '10px'}}/>
                                </>}
                            </div>
                        </div>
                    
                </Panel>
                { client.signup_config.acceptTermsEnabled && client.signup_config.termsURL && showUseTerms && 
                
                <Dialog visible={true} style={{ width: '90vw', height: '80vw' }} header="Termos de Uso" modal className="p-fluid" onHide={() => this.setState({showUseTerms: false})}>
                    <>
                    <object data={client.signup_config.termsURL} type="application/pdf" width="100%" height="100%">
                        <p><a href={client.signup_config.termsURL}></a></p>
                    </object>
                    </>
                </Dialog>
                }
            </div>
            </>
            )
        }
        

        if((client.config.authenticationType || "local") === "ADB2C"){
            return (<>
                <ADB2CLogin client={ client } onCallback={ this.callbackADB2C }/>
            </>);
        }

        return (
            <>
            <div style={{width: '100%', height: '100%', margin: 'auto',display:'flex', alignItems:'center', justifyContent: 'center', backgroundColor: client.custom_layout.secondaryBackgroundColor || ''}}>
                <Panel style={{width: '400px', margin: 'auto', borderColor: client.custom_layout.primaryBackgroundColor || '', backgroundColor: client.custom_layout.primaryBackgroundColor || '', borderWidth: 0}}>
                    <div className="p-grid" style={{backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                            <div className="p-col-12" style={{textAlign: 'center', marginTop:'20px'}}><img alt="Logo" src={client.logo} style={{maxWidth: '300px'}} /></div>
                            <div className="p-col-12" style={{textAlign: 'center', color: client.custom_layout.primaryFontColor || ''}}><b>{config.label}</b></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>E-mail</b></div>
                            <div className="p-col-12"><InputText disabled={authenticating} value={this.state.username || ""} onChange={(e) => this.setState({username: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>Senha</b></div>
                            <div className="p-col-12"><Password disabled={authenticating} feedback={false} value={this.state.password || ""} onChange={(e) => this.setState({password: e.target.value})} inputStyle={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{textAlign: 'center'}}>
                                <Button 
                                    disabled={authenticating} 
                                    label={"Entrar"}
                                    onClick={() => this.login()}
                                    style={{backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                />
                                <Button 
                                    disabled={authenticating} 
                                    label={"Esqueci a senha"}
                                    onClick={() => this.requestPasswordReset()}
                                    style={{marginLeft: '10px', backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                />
                                { authenticating && <div style={{marginTop: '10px'}}><ProgressBar mode="indeterminate"/></div> }
                                { authenticationFailed && <><br/><Message severity="error" text={"Credenciais incorretas"} closable={false} style={{marginTop: '10px'}}/></>}
                                { requestPasswordResetFailed && <><br/><Message severity="error" text={requestPasswordResetFailReason} closable={false} style={{marginTop: '10px'}}/></>}
                                { requestPasswordResetOk && <><br/><Message severity="success" text={"Se o e-mail informado for válido, um mensagem com instruções foi enviada."} closable={false} style={{marginTop: '10px'}}/></>}
                            </div>
                            { client.signup_config.allowed && <>
                                <div className="p-col-12" style={{textAlign: 'center', color: client.custom_layout.primaryFontColor || ''}}>
                                    <a href={client.use_custom_url ? `/signup` : `/${client.shortcode}/signup`}  style={{textAlign: 'center', color: client.custom_layout.primaryFontColor || ''}}>Cadastre-se aqui</a>
                                </div>
                            </>}
                        </div>
                    
                </Panel>
            </div>
            </>
        );
    }
}